import React, { useEffect, useRef } from "react";
import { useFormikContext } from "formik";
import Box from "@mui/material/Box";
import FormFields from "./FormFields";
import { useAssets } from "src/contexts/assets";
import LoadingProvider from "./LoadingProvider";
import FormActions from "./FormActions";
import useNotification from "src/hooks/notification";

export default function FormPage({
  currentAsset,
  shipmentItem,
  shipmentItemId,
  type,
  removing,
  toggleRemoveItem,
  shipmentId,
  shipment,
  isDraft,
  isActualDraft,
  isOnsiteInventory,
  onMarkAsReceived,
  sameLocation,
  project,
  overrideDisplayFields,
  displayType,
  closeItemDetails,
}) {
  const { setErrors, errors, submitCount } = useFormikContext();
  const { loadingMutation, updateAsset, createImage } = useAssets();
  const { notifyError } = useNotification();
  const hasErrors = Object.keys(errors).length > 0;
  const lastLoggedSubmitCount = useRef(-1);

  useEffect(() => {
    if (submitCount > 0 && submitCount !== lastLoggedSubmitCount.current) {
      if (hasErrors) {
        const missingFields = Object.keys(errors).join(", ");
        console.log(`🚨 Missing required field(s): ${missingFields}`);
        notifyError("Please fill out all required fields");
      }
      lastLoggedSubmitCount.current = submitCount;
    }
  }, [submitCount]);

  return (
    <LoadingProvider>
      <form
        id="assetForm"
        className="d-flex flex-column flex-grow-1 justify-content-between justify-content-md-start"
        style={{ position: "relative" }}
      >
        <FormFields
          type={type}
          asset={currentAsset}
          loading={loadingMutation}
          updateAsset={updateAsset}
          createImage={createImage}
          setErrors={setErrors}
          errors={errors}
          shipmentItem={shipmentItem}
          shipmentItemId={shipmentItemId}
          shipment={shipment}
          isDraft={isDraft}
          isActualDraft={isActualDraft}
          isOnsiteInventory={isOnsiteInventory}
          onMarkAsReceived={onMarkAsReceived}
          sameLocation={sameLocation}
          project={project}
          overrideDisplayFields={overrideDisplayFields}
          displayType={displayType}
        />
        <Box pt={10} />
        <FormActions
          shipmentId={shipmentId}
          shipment={shipment}
          removing={removing}
          toggleRemoveItem={toggleRemoveItem}
          closeItemDetails={closeItemDetails}
          asset={currentAsset}
        />
      </form>
    </LoadingProvider>
  );
}
